import React, {  Fragment, useRef } from "react";
import {  Draggable } from "@hello-pangea/dnd";


// a little function to help us with reordering the result

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
	// some basic styles to make the items look a bit nicer
	userSelect: "none",
	// padding: grid * 2,
	paddingLeft: 8,
	paddingTop: 2,
	paddingBottom: 2,
	margin: `0 0 ${grid}px 0`,
	fontWeight: 600,

	// change background colour if dragging
	// background: isDragging ? "lightgreen" : "grey",

	// styles we need to apply on draggables
	...draggableStyle,
});


const UnassignedServices = (props) => {
	const data = props.data;
	const provided = props.provided;
	const dataRef = useRef();
	dataRef.current = data;

	return (
		<Fragment>
			<div className="h-64 ml-10 font-semibold text-3xl text-text"></div>
			<div
			>
				{data.map((item, index) => (
					<div className="pt-3 m-0" key={String(item.id)}>
						<Draggable
							key={String(item.id)}
							draggableId={String(item.id)}
							index={index}
						>
							{(provided, snapshot) => (
								<span
									className="bg-primary py-0 px-2 text-white text-sm rounded-full"
									ref={provided.innerRef}
									{...provided.draggableProps}
									{...provided.dragHandleProps}
									style={getItemStyle(
										snapshot.isDragging,
										provided.draggableProps.style
									)}
								>
									{item.name}
								</span>
							)}
						</Draggable>
						{provided.placeholder}
					</div>
				))}
			</div>
		</Fragment>
	);
};

export default UnassignedServices;
